export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Robert Martinez',
      property: '12-Unit Apartment Building',
      location: 'Northeast El Paso',
      rating: 5,
      text: 'I inherited a 12-unit building from my father and had no interest in being a landlord. Half the tenants were great, half were problems. T-Rex bought the entire property with all tenants in place. They closed in 9 days and I walked away with $875,000 cash. The title company handled everything professionally. Best decision I made.',
      image: 'https://public.readdy.ai/ai/img_res/c5fbb3c38cc1e46b1f02be63b23de403.jpg'
    },
    {
      name: 'Jennifer Thompson',
      property: 'Duplex Portfolio (4 Properties)',
      location: 'Central & West El Paso',
      rating: 5,
      text: 'After 15 years of landlording, I was ready to retire. I owned 4 duplexes with 8 total units, all occupied. Traditional agents said it would take a year to sell them all. T-Rex purchased the entire portfolio in one transaction. Closed in 12 days, kept all tenants in place, and I got $740,000. Finally enjoying retirement!',
      image: 'https://readdy.ai/api/search-image?query=professional%20businesswoman%20real%20estate%20seller%20happy%20client%20testimonial%20portrait%20confident%20smile%20professional%20attire&width=150&height=150&seq=rental-test-002&orientation=squarish'
    },
    {
      name: 'David Chen',
      property: 'Single-Family Rental',
      location: 'East El Paso',
      rating: 5,
      text: 'My tenant stopped paying rent and I was facing a lengthy eviction process. T-Rex bought my property with the non-paying tenant still there. They handled the situation after closing. I received $165,000 and avoided months of legal battles and lost income. They truly understand difficult tenant situations.',
      image: 'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20real%20estate%20client%20satisfied%20testimonial%20portrait%20confident%20smile%20business%20casual&width=150&height=150&seq=rental-test-003&orientation=squarish'
    },
    {
      name: 'Maria Gonzalez',
      property: 'Triplex',
      location: 'South El Paso',
      rating: 5,
      text: 'I was relocating for work and needed to sell my triplex quickly. All three units were occupied with good tenants on year-long leases. T-Rex made a fair cash offer, honored all the leases, and closed in 8 days. My tenants were happy to stay, and I got $285,000 to start my new chapter. Highly recommend!',
      image: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20businesswoman%20real%20estate%20seller%20testimonial%20portrait%20happy%20smile%20professional%20attire&width=150&height=150&seq=rental-test-004&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What Landlords Say About Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real testimonials from landlords who sold their tenant occupied properties to T-Rex Real Estate.
          </p>
          <div className="flex items-center justify-center mt-6 space-x-2">
            <div className="flex">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-yellow-400 text-2xl"></i>
              ))}
            </div>
            <span className="text-2xl font-bold text-gray-900">4.9/5</span>
            <span className="text-gray-600">(200+ Reviews)</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="flex items-start space-x-4 mb-6">
                <div className="relative w-20 h-20 flex-shrink-0">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900">{testimonial.name}</h3>
                  <p className="text-teal-600 font-semibold">{testimonial.property}</p>
                  <p className="text-gray-500 text-sm">{testimonial.location}</p>
                  <div className="flex mt-2">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Join Hundreds of Satisfied Landlords</h3>
          <p className="text-xl text-teal-100 mb-8 max-w-2xl mx-auto">
            We've helped over 200 landlords sell their tenant occupied properties quickly and professionally. You could be next.
          </p>
          <a 
            href="tel:+1-915-206-5814"
            className="inline-flex items-center bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-bold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (915) 206-5814 Now
          </a>
        </div>
      </div>
    </section>
  );
}